import React, { useState } from "react";
import ProtectedAccessModal from "./ProtectedAccessModal";

const COOKIE_NAME = "dev_access";

function getCookie(name) {
  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(name + "="));
  return match ? match.split("=")[1] : null;
}

export default function ProtectedRoute({ children }) {
  // Initialise directly from cookie — no waiting for useEffect
  const [authorized, setAuthorized] = useState(
    () => getCookie(COOKIE_NAME) === "1"
  );

  if (!authorized) {
    return (
      <ProtectedAccessModal
        open={true}
        onSuccess={() => setAuthorized(true)}
      />
    );
  }

  return children;
}